import { PropsWithChildren } from 'react';
import { useNetwork } from 'wagmi';
import { WrongChain } from '#components/WrongChain/WrongChain';
export const ChainHandler = ({
  children
}: PropsWithChildren) => {
  const {
    chain
  } = useNetwork();
  const isWrongChain = chain !== undefined && chain.id !== Number(process.env.NEXT_PUBLIC_TARGET_CHAIN_ID);
  return isWrongChain ? <WrongChain /> : children;
};